import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { COMPANY } from "../data/site";

export const OfferModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("omk_offer_seen")) return;
    const t = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem("omk_offer_seen", "1");
    }, 14000);
    return () => clearTimeout(t);
  }, []);

  const goForm = () => {
    setOpen(false);
    setTimeout(() => {
      const el = document.querySelector("#contact");
      if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
      else if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 300);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/80 p-6 backdrop-blur-sm"
          onClick={() => setOpen(false)}
          data-testid="offer-modal-overlay"
        >
          <motion.div
            initial={{ scale: 0.7, y: 60, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-2xl border-4 border-copper bg-surface shadow-2xl shadow-copper/20"
            data-testid="offer-modal"
          >
            {["left-2 top-2", "right-2 top-2", "left-2 bottom-2", "right-2 bottom-2"].map((p) => (
              <span key={p} className={`absolute ${p} z-10 h-2 w-2 rounded-full bg-zinc-500`} aria-hidden="true" />
            ))}

            <div className="hazard" aria-hidden="true" />

            <div className="relative p-8 lg:p-12">
              <button
                onClick={() => setOpen(false)}
                data-testid="offer-modal-close"
                aria-label="Close offer popup"
                className="absolute right-5 top-5 text-zinc-500 transition-colors duration-300 hover:text-zinc-100"
              >
                <X size={22} />
              </button>

              <p className="font-stencil text-xs text-copper">Copper ingots // direct from Zambia</p>

              <motion.h2
                animate={{ scale: [1, 1.05, 1, 1.03, 1] }}
                transition={{ repeat: Infinity, duration: 1.6, times: [0, 0.18, 0.36, 0.54, 1], ease: "easeInOut" }}
                className="font-display mt-5 origin-left text-5xl font-semibold uppercase leading-[0.95] text-zinc-100 sm:text-7xl"
                data-testid="offer-modal-headline"
              >
                10% off<br /><span className="text-copper">LME prices.</span>
              </motion.h2>

              <p className="mt-6 max-w-md text-sm leading-relaxed text-zinc-400 md:text-base">
                Minimum order 100 MT · Shipping worldwide · 30% advance, balance on arrival at your destination port. Text a founder and lock your allocation.
              </p>

              <div className="mt-9 grid gap-3 sm:grid-cols-2">
                <a
                  href={COMPANY.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="offer-modal-whatsapp-zm"
                  className="flex items-center justify-between gap-3 bg-copper px-5 py-4 transition-colors duration-300 hover:bg-copper-light"
                >
                  <span className="flex items-center gap-3 font-mono text-sm font-medium text-ink">
                    <img src="https://flagcdn.com/w40/zm.png" alt="Zambia flag" className="h-4 w-6 object-cover" />
                    {COMPANY.phone}
                  </span>
                  <span className="font-stencil text-[10px] text-ink/70">ZM Line</span>
                </a>
                <a
                  href={COMPANY.whatsapp2}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="offer-modal-whatsapp-in"
                  className="flex items-center justify-between gap-3 bg-copper px-5 py-4 transition-colors duration-300 hover:bg-copper-light"
                >
                  <span className="flex items-center gap-3 font-mono text-sm font-medium text-ink">
                    <img src="https://flagcdn.com/w40/in.png" alt="India flag" className="h-4 w-6 object-cover" />
                    {COMPANY.phone2}
                  </span>
                  <span className="font-stencil text-[10px] text-ink/70">IN Line</span>
                </a>
              </div>

              <button
                onClick={goForm}
                data-testid="offer-modal-form-btn"
                className="mt-3 w-full border border-zinc-700 px-5 py-4 font-mono-label text-[11px] text-zinc-200 transition-colors duration-300 hover:border-copper hover:text-copper-light"
              >
                Use the enquiry form instead
              </button>

              <div className="mt-8 flex items-center justify-between gap-4">
                <div className="barcode w-36" aria-hidden="true" />
                <p className="font-mono text-[9px] tracking-widest text-zinc-600">OMK-COPPER-DEAL-001</p>
              </div>
            </div>

            <div className="hazard" aria-hidden="true" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
